rs.module("jobs/irc415btestexceptions",

    ["controls/data/grid"],

    function (gridModule) {

        //
        // Initialize the module
        //
        function initialize(lrsGridApi, jsSelectors, ajaxUrl) {

            var filter = $.js(jsSelectors.filter);
            var yearsSelect = filter.js(jsSelectors.yearsSelect);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Hook up select event on the selectorto reload the grid data via ajax
            yearsSelect.on('change', function () {

                loadingSpinner.show();

                gridModule.update(

                    ajaxUrl,
                    { selectedYear: this.value },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);